import { getThemeColors } from '../../utils/chartTheme';

export const getOptions = () => {
    const tc = getThemeColors();
    return {
        maintainAspectRatio: true,
        responsive: true,
        title: {
            display: true,
            text: ''
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let value = context.chart.data.datasets[context.datasetIndex].data[context.dataIndex];
                        let newlabel = value + ' kWh/kWp';
                        return [newlabel];
                    }
                }
            },
            datalabels: {
                anchor: 'center',
                color: function (context) {
                    var value = context.dataset.data[context.dataIndex];
                    return value > 200 ? '#fff' : tc.datalabelColor;
                },
                align: 'center',
                display: true,
                formatter: function (value, context) {
                    // Ist-Dataset (index 1): show symbol for Soll comparison
                    if (context.datasetIndex === 1 && context.chart.data.Vergleich) {
                        const above = context.chart.data.Vergleich[context.dataIndex];
                        return Math.round(value) + (above ? ' ✓' : ' △');
                    }
                    return Math.round(value);
                },
                font: {
                    weight: 'normal'
                }
            },
            peakMarker: { datasetIndex: 1, color: '#22c55e' }
        },
        scales: {
            x: {
                grid: { color: tc.gridColor },
                ticks: {
                    autoSkip: false,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'Monat',
                    color: tc.textColor
                }
            },
            y: {
                grid: { color: tc.gridColor },
                ticks: {
                    beginAtZero: true,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'kWh/kWp',
                    color: tc.textColor
                }
            }
        }
    };
};
